import React, { Fragment, useState, useEffect, useRef, useContext } from 'react';
import T from 'prop-types';
import cx from 'classnames';
import ReCAPTCHA from 'react-google-recaptcha';

import ReportWidgetCard from './ReportWidgetCard';
import Button from '../../../../../components/Buttons/Button';
import InputText from '../../../../../components/Inputs/InputText';
import { InitialDataContext } from '../context';
import helpers from '../../../../../utils/helpers';

const validateEmail = (email) =>
  !email || !helpers.validateEmail(email) || email.includes('+')
    ? 'Please enter a valid email address'
    : '';

const AskForReferral = ({ errors, isProcessing, setProcessing, onSubmit }) => {
  const recaptchaRef = useRef();

  const [shareEmail, setShareEmail] = useState('');
  const [error, setError] = useState('');

  const { sitekey } = useContext(InitialDataContext);

  useEffect(() => {
    setError(errors.shareEmail || '');
  }, [errors.shareEmail]);

  const submitDisabled = isProcessing || !shareEmail.trim().length || !!error.length;

  const handleEmailChange = (email) => {
    setShareEmail(email);
    setError(validateEmail(email));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (submitDisabled) return;

    setProcessing(true);

    if (recaptchaRef.current) {
      recaptchaRef.current.reset();
      recaptchaRef.current.executeAsync().then((token) => {
        if (error.length) setProcessing(false);
        else onSubmit(token, { referral: { email: shareEmail } });
      });
    } else {
      // For test environment
      onSubmit('test-token', { referral: { email: shareEmail } });
    }
  };

  return (
    <Fragment>
      <ReportWidgetCard className="ask-for-referral">
        <header className="ask-for-referral__header">
          <div className="ask-for-referral__image" />
          <h2 className="ask-for-referral__title">Unlock Your Free Report</h2>
        </header>
        <div className="ask-for-referral__body">
          <p className="ask-for-referral__paragraph">
            Share with a colleague to access your report
          </p>

          <form className="ask-for-referral__form" onSubmit={handleSubmit}>
            <fieldset className={cx('form-group pos-rel', { 'has-error': Boolean(error) })}>
              <InputText
                placeholder="Colleague's Business Email"
                type="text"
                onChange={handleEmailChange}
                value={shareEmail}
              />
            </fieldset>

            <Button
              type="submit"
              loading={isProcessing}
              disabled={submitDisabled}
              className="ask-for-referral__btn-submit"
            >
              {isProcessing ? 'Verifying...' : 'Share My Report'}
            </Button>

            {error && <div className="error-message">{error}</div>}
          </form>
        </div>
      </ReportWidgetCard>
      {Boolean(sitekey) && <ReCAPTCHA ref={recaptchaRef} size="invisible" sitekey={sitekey} />}
    </Fragment>
  );
};

AskForReferral.propTypes = {
  errors: T.object.isRequired,
  isProcessing: T.bool.isRequired,
  setProcessing: T.func.isRequired,
  onSubmit: T.func.isRequired,
};

export default AskForReferral;
